import React from "react";
import Switch from "../../../Switch";

function OutputBoolean({ field, object, onChange, ...rest }) {
  const value = object[field];

  if (field === "isVatable") {
    return value === true ? "VATable" : "Non-Vatable";
  }

  if (field === "isActive") {
    const stopPropagation = (e) => e.stopPropagation();
    return (
      <div
        className={`output-boolean-switch d-flex justify-content-center${value ? " output-boolean-switch--active" : ""}`}
        onClick={stopPropagation}
        onPointerDown={stopPropagation}
        onPointerUp={stopPropagation}
      >
        <Switch
          id={`output-isActive-${object?.id ?? object?.objectId ?? ""}`}
          checked={!!value}
          onChange={onChange ? (v) => onChange(field, v) : undefined}
          disabled={!onChange}
          {...rest}
        />
      </div>
    );
  }

  if (value) {
    return "Yes";
  } else {
    return "No";
  }
}

export default OutputBoolean;
